import { createSelector } from 'reselect'

import { selectLandingState } from './selectLandingState'

export const selectLandingSelectedCategory = createSelector(
  [selectLandingState],
  ({ selectedCategory }) => selectedCategory
)
